/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPointFromJSON, StreemApiPointToJSON, } from './';
export function LightPointLightFromJSON(json) {
    return LightPointLightFromJSONTyped(json, false);
}
export function LightPointLightFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'position': !exists(json, 'position') ? undefined : StreemApiPointFromJSON(json['position']),
        'temperatureKelvin': !exists(json, 'temperature_kelvin') ? undefined : json['temperature_kelvin'],
        'intensityLumens': !exists(json, 'intensity_lumens') ? undefined : json['intensity_lumens'],
    };
}
export function LightPointLightToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'position': StreemApiPointToJSON(value.position),
        'temperature_kelvin': value.temperatureKelvin,
        'intensity_lumens': value.intensityLumens,
    };
}
//# sourceMappingURL=LightPointLight.js.map